export default __webpack_public_path__ + "images/7790a2ec52cbfc0c5048ab2054473ade-painting.jpg";